// extracted by mini-css-extract-plugin
export var printerCard = "_b5-1";
export var printerCardConfigured = "_b5-2";
export var printerCardError = "_b5-3";
export var printerCardsContainer = "_b5-0";
export var printerIcon = "_b5-8";
export var printerIconConfigured = "_b5-5";
export var printerIconContainer = "_b5-4";
export var printerIconError = "_b5-6";
export var printerIconUnconfigured = "_b5-7";
export var workstationsTableCard = "_b5-9";